import { render } from "./ExcursionModal.vue?vue&type=template&id=4862d637&scoped=true"
import script from "./ExcursionModal.vue?vue&type=script&lang=js"
export * from "./ExcursionModal.vue?vue&type=script&lang=js"

import "./ExcursionModal.vue?vue&type=style&index=0&id=4862d637&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4862d637"]])

export default __exports__